export default __webpack_public_path__ + "static/media/ok.fcfd3299.svg";